import type { FontSource } from '@wysiwyg/pdf-export';

export const DEFAULT_FONT = "'Roboto Condensed', sans-serif";

export const pdfFontSources: FontSource[] = [
  { family: 'Roboto Condensed', weight: 400, url: '/fonts/RobotoCondensed-Variable.ttf' },
  { family: 'Roboto Condensed', weight: 600, url: '/fonts/RobotoCondensed-Variable.ttf' },
  { family: 'Roboto Condensed', weight: 700, url: '/fonts/RobotoCondensed-Variable.ttf' },
  { family: 'Roboto Condensed', weight: 400, style: 'italic', url: '/fonts/RobotoCondensed-Italic-Variable.ttf' },
  { family: 'Roboto Condensed', weight: 600, style: 'italic', url: '/fonts/RobotoCondensed-Italic-Variable.ttf' },
  { family: 'Roboto Condensed', weight: 700, style: 'italic', url: '/fonts/RobotoCondensed-Italic-Variable.ttf' },
];
